import { computed } from 'vue'

// store is alredy selected a specific state, so we can use it directly
export default function (store) {
    const userInputs = computed(() => {
        return store.userInputs
    })

    const steps = computed(() => {
        return store.steps
    })

    const currentStep = computed(() => {
        return store.currentStep
    })

    const finalStepName = steps.value.toReversed().name

    const allStepsComplete = computed(() => {
        return !!(
            steps.value.filter((stepData) => !stepData.completed).length === 0
        )
    })

    const currentStepName = computed(() => {
        return allStepsComplete.value
            ? finalStepName
            : steps.value.find((stepData) => !stepData.completed).name
    })

    return {
        userInputs,
        steps,
        currentStep,
        currentStepName
    }
}
